<template>
  <sider-subpage-elements :items="filtersArray" :active-value="filterId" :is-loading="isLoading" @change="openFilter" />
</template>

<script>
import SiderSubpageElements from '@/components/SiderSubpageElements';

import { get, call } from 'vuex-pathify';

export default {
  name: 'SiderSheetsSection',
  components: {
    SiderSubpageElements,
  },
  data: () => ({
    isLoading: false,
    filterIdProxy: null,
  }),
  watch: {
    filterId: {
      handler(nV) {
        this.filterIdProxy = nV;
      },
      immediate: true,
    },
  },
  computed: {
    sheetsFilters: get('sheets/filters'),
    filterId() {
      return this.$route.meta.default === 'sheets' && this.$route.query.filter ? +this.$route.query.filter : null;
    },
    filtersArray() {
      const lastUsedSheetsIds = JSON.parse(localStorage.getItem('last-used-sheets') || '[]') || [];
      const order = ['predefined', 'owner', 'shared'];

      return Object.entries(this.sheetsFilters ?? {})
        .flatMap(([role, items]) =>
          items.map(item => ({
            id: item.id,
            name: item.name,
            role,
          }))
        )
        .sort((a, b) => {
          const aIndex = lastUsedSheetsIds.indexOf(a.id);
          const bIndex = lastUsedSheetsIds.indexOf(b.id);
          if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
          else if (aIndex !== -1) return -1;
          else if (bIndex !== -1) return 1;
          else if (order.indexOf(a.role) - order.indexOf(b.role) === 0) return a['name'].localeCompare(b['name']);
          return order.indexOf(a.role) - order.indexOf(b.role);
        });
    },
  },
  methods: {
    getFilters: call('sheets/getFilters'),
    openFilter(filterId) {
      this.$nextTick(() => (this.filterIdProxy = this.filterId));
      if (!filterId) return;
      const filterData = Object.values(this.sheetsFilters)
        .flat()
        .find(filter => filter.id === filterId);
      this.$router.push({
        name: 'sheetsLayer',
        params: {
          lid: filterData.layer_id,
        },
        query: {
          filter: filterData.id,
        },
      });
    },
    async parseSheets() {
      if (Object.values(this.sheetsFilters).length) return (this.isLoading = false);
      this.isLoading = true;
      try {
        await this.getFilters();
      } catch (error) {
        console.error();
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.parseSheets();
  },
};
</script>

<style lang="scss" scoped>
.sider-sheets-section {
  height: 100%;
  transition: opacity 0.2s ease allow-discrete;
}
.sider-sheets-section__hidden {
  opacity: 0 !important;
  pointer-events: none !important;
}
</style>
